import "../../index34.css";
import { jsxs as l, jsx as t } from "react/jsx-runtime";
import { _ as n } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
const o = "_input-label_jy7op_1", u = "_disabled_jy7op_7", p = "_required_jy7op_11", e = {
  inputLabel: o,
  disabled: u,
  required: p
};
function f(r) {
  const {
    children: i,
    className: s,
    disabled: a,
    required: d
  } = r;
  return i ? /* @__PURE__ */ l(
    "div",
    {
      className: n(
        e.inputLabel,
        a && e.disabled,
        s
      ),
      children: [
        i,
        d && /* @__PURE__ */ t("span", { "aria-hidden": !0, className: e.required, children: "*" })
      ]
    }
  ) : null;
}
export {
  f as default
};
